<div

  class="trial-booking-widget"

  [attr.aria-busy]="isSubmitting() || isWidgetShellLoading()"

>

  @if (isWidgetShellLoading()) {

    <div

      class="trial-booking-state trial-booking-state--loading"

      role="status"

      aria-label="widget-loading"

    >

      <div class="trial-booking-spinner" aria-hidden="true"></div>

      <p class="loading-message">Loading widget...</p>

    </div>

  } @else if (widgetLoadErrorMessage()) {

    <div

      class="trial-booking-state trial-booking-state--error error-message"

      role="alert"

      aria-label="widget-load-error"

    >

      {{ widgetLoadErrorMessage() }}

    </div>

  } @else if (submitSuccess()) {

    <div

      class="trial-booking-state trial-booking-state--success success-message"

      role="status"

      aria-label="trial-booking-success"

    >

      <h3>Trial Booking Confirmed!</h3>

      <p>Thank you for booking a trial. We'll be in touch shortly with more details.</p>

    </div>

  } @else {

    <div class="trial-booking-form">

      <section

        class="trial-date-card"

        [class.trial-date-card--selected]="!!trialBookingDate()"

        aria-labelledby="trialDateHeading"

      >

        <h2 class="trial-date-card__title" id="trialDateHeading">

          Trial booking date

        </h2>

        <p class="trial-date-card__hint">

          Select the day you would like to try a class or session.

        </p>

        <div class="trial-date-field">

          <label class="trial-date-field__label" for="trialBookingDateInput">

            Date

          </label>

          <input

            id="trialBookingDateInput"

            class="trial-date-field__input"

            type="date"

            aria-label="trial-booking-date"

            [min]="minTrialDateIso()"

            [value]="trialBookingDate()"

            (input)="onTrialDateInput($event)"

            (change)="onTrialDateInput($event)"

          />

        </div>

      </section>



      <section

        class="trial-lead-section"

        aria-label="trial-booking-contact-details"

      >

        @if (widgetId()) {

          <ufp-lead-capture-v2

            [widgetId]="widgetId()"

            [trialBookingEmbed]="true"

            [defaultTenantUuid]="defaultTenantUuid()"

            (tourFormCompleteChange)="onTourFormCompleteChange($event)"

            (tenantChange)="onTenantChange($event)"

          />

        }

      </section>



      <footer

        class="submit-section widget-submit-section"

        [class.disabled]="!canSubmit() && !recaptchaFlow.showV2Challenge()"

      >

        @if (submissionError()) {

          <div

            class="error-message submit-error"

            role="alert"

            aria-label="submission-error"

          >

            {{ submissionError() }}

          </div>

        }



        @if (!canSubmit() && !recaptchaFlow.showV2Challenge() && !isSubmitting()) {

          <p class="submit-hint" id="trialBookingSubmitHint">

            Complete the date and form above to enable booking.

          </p>

        }



        @if (recaptchaFlow.showV2Challenge()) {

          <ufp-widget-recaptcha-v2-section

            [hint]="recaptchaV2Hint"

            (resolved)="onRecaptchaV2Resolved($event)"

            (failed)="onRecaptchaV2Failed()"

          />

        }



        <button

          type="button"

          class="submit-button"

          (click)="onSubmit()"

          [disabled]="isSubmitting() || !canSubmit() || recaptchaFlow.showV2Challenge()"

          aria-label="book-trial"

          [attr.aria-describedby]="

            !canSubmit() && !recaptchaFlow.showV2Challenge()

              ? 'trialBookingSubmitHint'

              : null

          "

        >

          {{ isSubmitting() ? 'Booking Trial...' : 'Book Trial' }}

        </button>

      </footer>

    </div>

  }



  <ufp-widget-processing-overlay

    [visible]="isSubmitting() && !recaptchaFlow.showV2Challenge()"

    message="Processing your booking..."

  />

</div>


